export const enPlanetwin365 = {
  modal: {
    geolocation: {
      content: 'Planetwin365.it is about to ask you to access your location for better use of the service',
      title: 'Geolocation Planetwin365',
    },
  },
  namespaceTest: 'Hello Planetwin365',
};
